// Converts a YouTube or Vimeo URL into an embeddable iframe src.
export function toEmbedUrl(url) {
  if (!url) return null;
  const clean = url.trim();

  // YouTube
  const yt =
    clean.match(/youtube\.com\/watch\?v=([\w-]+)/) ||
    clean.match(/youtu\.be\/([\w-]+)/) ||
    clean.match(/youtube\.com\/embed\/([\w-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  // Vimeo (links "não listados" trazem um código extra: vimeo.com/ID/HASH ou ?h=HASH)
  const vm =
    clean.match(/player\.vimeo\.com\/video\/(\d+)/) ||
    clean.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) {
    const h = clean.match(/[?&]h=([a-f0-9]+)/i) || clean.match(/vimeo\.com\/(?:video\/)?\d+\/([a-f0-9]{6,})/i);
    return `https://player.vimeo.com/video/${vm[1]}${h ? `?h=${h[1]}` : ""}`;
  }

  return null;
}
